import { HTTP } from '../../http-common'

export default {
  state: {
    loadedVoltageTypes: []
  },
  getters: {
    loadedVoltageTypes (state) {
      return state.loadedVoltageTypes
    }
  },
  mutations: {
    setLoadedVoltageTypes (state, payload) {
      state.loadedVoltageTypes = payload
    },
    createVoltageType (state, payload) {
      state.loadedVoltageTypes.push(payload)
    },
    updateVoltageType (state, payload) {
      state.loadedVoltageTypes = state.loadedVoltageTypes.map(voltageType => voltageType.id === payload.id ? payload : voltageType)
    },
    removeVoltageType (state, id) {
      state.loadedVoltageTypes = state.loadedVoltageTypes.filter(voltageType => {
        return voltageType.id !== id
      })
    },
    clearLoadedVoltageTypes (state) {
      state.loadedVoltageTypes = []
    }
  },
  actions: {
    loadVoltageTypes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedVoltageTypes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('voltage_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedVoltageTypes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createVoltageType ({ commit, getters }, payload) {
      console.log('createVoltageType')
      commit('clearError')
      commit('setLoading', true)
      const newVoltageType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('voltage_type.json/', newVoltageType)
          .then(result => {
            console.log(result)
            commit('createVoltageType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateVoltageType ({ commit, getters }, payload) {
      console.log('updateVoltageType')
      commit('clearError')
      commit('setLoading', true)
      const voltageType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`voltage_type.json/${payload.id}/`, voltageType)
          .then(result => {
            console.log(result)
            commit('updateVoltageType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeVoltageType ({ commit }, payload) {
      console.log('removeVoltageType')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`voltage_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeVoltageType', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedVoltageTypes ({ commit }) {
      commit('clearLoadedVoltageTypes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/voltage_type/index.js